/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
export const MQ_MIN_WIDTH = 769

export const IDLE_TIMEOUT_MINUTES = 20
export const ONE_SECOND = 1000
export const MINUTE_MS = 60 * ONE_SECOND

export const INVENTORY_LOOKUP_BFF_PATH = '/stores'
